export default __webpack_public_path__ + "static/media/icon-card-advanced-settings.dbe760f7.svg";